import styled from 'styled-components';
import { tint } from 'polished';

export const NoticeBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  margin-top: 16px;
  border: 1px solid ${({ theme }) => theme.defaultColors.info};
  background: ${({ theme }) => tint(0.9, theme.defaultColors.info)};
  border-radius: 4px;
  color: ${({ theme }) => theme.defaultColors.info};
  flex-grow: 1;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

export const Content = styled.div`
  font-size: 14px;
  margin-top: 10px;
`;
